export function InvoiceEditCtrl (
  $scope,
  $state,
  $translate,
  $uibModalInstance,
  confirm,
  invoice,
  messages,
  modalApi,
  sessionObjAPI,
  templatedWording,
  workshopAPI
) {

  $scope.company       = sessionObjAPI.company();
  $scope.distanceLabel = sessionObjAPI.getDistanceLabel();
  $scope.invoice       = invoice;

  $scope.editInvoice = {
    customer_order_number: $scope.invoice.customer_order_number,
    description          : $scope.invoice.description,
    follow_up_comment    : $scope.invoice.follow_up_comment,
    follow_up_date       : $scope.invoice.follow_up_date,
    id                   : $scope.invoice.id,
    job_card_note        : $scope.invoice.job_card_note,
    next_service_hours   : $scope.invoice.next_service_hours,
    note                 : $scope.invoice.note,
    odometer             : $scope.invoice.odometer,
    vehicle_hours        : $scope.invoice.vehicle_hours
  };

  $scope.addJobCardTemplates = function () {
    templatedWording.addTemplate('job_card')
    .then(templates => {
      angular.forEach(templates, template => {
        $scope.invoice.job_card_note = $scope.invoice.job_card_note
          ? `${ $scope.invoice.job_card_note }\n\n${ template.wording }`
          : template.wording;
      });
    });
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('invoice')
    .then(templates => {
      angular.forEach(templates, template => {
        $scope.invoice.note = $scope.invoice.note
          ? `${ $scope.invoice.note }\n\n${ template.wording }`
          : template.wording;
      });
    });
  };

  $scope.followUp = function () {
    modalApi.addNote({
      note: $scope.invoice.follow_up_comment
    })
    .then(note => {
      $scope.editInvoice.follow_up_comment = note;
    });
  };

  $scope.isSynced = function() {
    return ($scope.company.has_xero && !$scope.invoice.needs_xero_sync)
      || ($scope.company.has_myob && !$scope.invoice.needs_myob_sync)
      || ($scope.company.has_qbo && !$scope.invoice.needs_qbo_sync);
  };

  $scope.save = function () {
    confirm.generic($translate.instant('JS_SPACE.MESSAGES.SAVE_THIS_CHANGE'))
    .then(() => workshopAPI.patch('/invoice/edit_invoice_after_process', $scope.editInvoice, 'invoice'))
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      $uibModalInstance.close();

      $state.reload();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };
}